import { WorkflowEdgeType, WorkflowStepType } from '@bandido/shared/constants';

import WorkflowDiagramStep from './components/WorkflowDiagram/WorkflowDiagramStep';
import CustomEdge from './components/WorkflowDiagram/CustomEdge';

export const stepTypes = {
  [WorkflowStepType.INITIAL]: WorkflowDiagramStep,
  [WorkflowStepType.CUSTOM]: WorkflowDiagramStep,
  [WorkflowStepType.FINAL]: WorkflowDiagramStep,
};

export const edgeTypes = {
  [WorkflowEdgeType.CUSTOM]: CustomEdge,
};
